<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import type { IBonusCreateManuallyPayload } from '@modules/players-bonuses/submodules/components/types';
import VCard from '@components/card/VCard/VCard.vue';
import BonusChangeForm from '@modules/players-bonuses/submodules/components/BonusChangeForm/BonusChangeForm.vue';
import { TRANSLATION_PLAYER_BONUS_EDIT } from '@modules/players-bonuses/submodules/edit/constants';
import { usePlayerBonusEditMutation } from '@modules/players-bonuses/submodules/edit/mutations';

import usePlayerBonusQuery from '../../queries/usePlayerBonusQuery';

const route = useRoute();

const id = computed<string>(() => (String(route.params.id)));

const { data } = usePlayerBonusQuery(id);
const {
  mutate: editBonus,
  isLoading,
  errors,
  clearError,
} = usePlayerBonusEditMutation(id);

function editHandler(formData: IBonusCreateManuallyPayload): void {
  editBonus({ ...data.value?.bonus, ...formData });
}
</script>

<template>
  <VCard v-data-qa-auto-id="'PlayersBonusesEditPage'"
    :title="$getTranslation(TRANSLATION_PLAYER_BONUS_EDIT, 'HEADER')"
    type="form"
  >
    <BonusChangeForm
      :data="data"
      :date-label="$getTranslation(TRANSLATION_PLAYER_BONUS_EDIT, 'DATE')"
      :is-loading="isLoading"
      :btn-submit-label="$getTranslation(TRANSLATION_PLAYER_BONUS_EDIT, 'SAVE')"
      :back-button-label="$getTranslation(TRANSLATION_PLAYER_BONUS_EDIT, 'BACK')"
      :bonus-amount-label="$getTranslation(TRANSLATION_PLAYER_BONUS_EDIT, 'BONUS')"
      :aasm-state-label="$getTranslation(TRANSLATION_PLAYER_BONUS_EDIT, 'AASM_STATE')"
      :cid-label="$getTranslation(TRANSLATION_PLAYER_BONUS_EDIT, 'CID')"
      :errors="errors"
      @submit="editHandler($event)"
      @interacted="clearError"
    />
  </VCard>
</template>
